import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IconsEnum} from '../../../shared-icons/models/icons.enum';

@Component({
  selector: 'app-successful-event-fab',
  templateUrl: './successful-event-fab.component.html',
  styleUrls: ['./successful-event-fab.component.scss'],
  standalone: false,
})
export class SuccessfulEventFabComponent implements OnInit {
  readonly icons = IconsEnum;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() Response: {count: number; type: 'AO' | 'API'};
  @Input() count: number;
  @Input() type: 'AO' | 'API';
  @Output() readonly buttonClick = new EventEmitter<void>();

  colour: string;

  ngOnInit(): void {
    this.colour = this.type === 'AO' ? 'success' : 'secondary';
  }
}
